module.exports = __webpack_public_path__ + "img/_super_01.2fd30953.jpg";